module.exports = __webpack_public_path__ + "img/電気回路_4_7_3.3fd6f7e8.png";